module.exports = __webpack_public_path__ + "img/readme-success.6f0995a1.png";